import { render } from "./Traduci.vue?vue&type=template&id=94e77bf6&scoped=true"
import script from "./Traduci.vue?vue&type=script&lang=js"
export * from "./Traduci.vue?vue&type=script&lang=js"

import "./Traduci.vue?vue&type=style&index=0&id=94e77bf6&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e77bf6"]])

export default __exports__